import { useBuilderContext } from '../context/BuilderContext';
import { CampaignWeightSection } from './config/CampaignWeightSection';
import { ParticipantsSection } from './config/ParticipantsSection';
import { PrivacySection } from './config/PrivacySection';
import { TranslationsSection } from './config/TranslationsSection';

export function StepConfig() {
  const { form } = useBuilderContext();

  // RN-009: Campaign weight and participant rules only apply to 'general' surveys.
  // For 'personalizada' and 'pulso_especifica' these sections are excluded entirely from the UI
  // (fields are also omitted from the outbound payload — see useCreateSurvey.ts).
  const isGeneralSurvey = form.surveyType === 'general';
  // Privacy/anonymity only applies to surveys targeting specific people or meetings.
  const showPrivacy = form.surveyType === 'personalizada';

  return (
    <>
      {isGeneralSurvey && <CampaignWeightSection />}
      {isGeneralSurvey && <ParticipantsSection />}
      {showPrivacy && <PrivacySection />}
      <TranslationsSection />
    </>
  );
}
